<template>
    <div class="px-5 pt-3 pb-2 mb-5">
        
        <div>
            <div class="mb-2">
                <breadCrumbs :routesArray="routesArray"></breadCrumbs>
            </div>
            <div class="items-center justify-between flex">
                <div class="title flex items-center">
                    <h1>{{presentTemplateObject.title}}</h1>
                </div>
                <button class="ml-1.5 flex" :class="controlsArray.length == 0 ? 'filterButtonDisable pointer-events-none' : 'filterButton'" @click="filterOpen">
                    <img  v-if="controlsArray.length == 0" src="@/assets/filterIconDisabled.svg" class="filterIcon"/>
                    <img v-else src="@/assets/filterIcon.svg" class="filterIcon"/>
                    Filters
                </button>
            </div>
            <div class="mt-3">
                <p class="text-xs">
                    This course helps you to Understand current data protection legislation and underlying principles. It also helps you to Understand what Privacy Awareness is, what PII is, PII Processing, Individual Rights, Cross Border Transfers, PII Breaches, Privacy By Design. This course helps you
                    to understand what Information Security is, awareness on information security, different kinds of security breaches happening in daily life, physical security, email security, Knowing your responsibilities when dealing with Information Security.
                </p>
            </div>
            <div>
                <tableData :tableRowData="controlsArray" :headersData="headers" :loadData="dataLoading"></tableData>
                 <div v-if="toolTipActive">
          		    <tool-tip :tipText="toolTipText"></tool-tip>
        	    </div>
            </div>
            <popup v-if="createTaskPopup" :popUp="createTaskPopup">
                <template v-slot:header>
                    <div class="flex items-center justify-between popupheadingcontainer rounded">
                        <h1>Tasks from Templates</h1>

                        <button class="float-right text-3xl" @click="onCloseAddPopup()">
                            <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                        </button>
                    </div>
                </template>

                <div class="popup-business">
                    <div>
                        <div>
                            <div class="statuscontainer popupbodycontainer">
                                <div class="formcontainer flex flex-col">
                                    <div class="upperspacing">
                                        <label for="number" class="controllabel">Title</label><br />
                                        <input class="inputboxstyling mt-2" placeholder="Task Name"  v-model.trim="templateTaskObj.mainTaskName" :class="{'is-invalid': v$.templateTaskObj.mainTaskName.$error }"/>
                                        <div v-if="v$.templateTaskObj.mainTaskName.$error " class="text-red-500">
                                            <div class="error-text" v-if="v$.templateTaskObj.mainTaskName.required.$invalid ">Required</div>
                                        </div>
                                    </div>
                                    <div class="row flex flex-row upperspacing w-full gap-2">
                                        <div class="w-1/2">
                                            <label class="controllabel text-xs">Start Date</label>
                                            <input
                                                type="date"
                                                class="inputboxstyling mt-2"
                                                @focus="openCalendar"
                                                :min="today"
                                                onkeydown = "return false"
                                                @change="checkForStartDate"
                                                placeholder="Select Start Date"
                                                v-model="templateTaskObj.startDate"
                                                :class="{'is-invalid': v$.templateTaskObj.startDate.$error }"
                                            />
                                            <div v-if="v$.templateTaskObj.startDate.$error " class="text-red-500">
                                                <div class="error-text" v-if="v$.templateTaskObj.startDate.required.$invalid ">Required</div>
                                            </div>
                                        </div>
                                        <div class="w-1/2">
                                            <label class="controllabel text-xs">Due Date</label>
                                            <input
                                                type="date"
                                                class="inputboxstyling mt-2"
                                                @focus="openCalendar"
                                                onkeydown = "return false"
                                                :min="templateTaskObj.startDate||today"
                                                @change="checkForStartDate"
                                                placeholder="Select Start Date"
                                                v-model="templateTaskObj.dueDate"
                                                :class="{'is-invalid': v$.templateTaskObj.dueDate.$error }"
                                            />
                                            <div v-if="v$.templateTaskObj.dueDate.$error " class="text-red-500">
                                                <div class="error-text" v-if="v$.templateTaskObj.dueDate.required.$invalid ">Required</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="">
                                        <!-- <div class="w-1/2">
                                            <label class="controllabel text-xs">Control Number</label>
                                            <input class="inputboxstyling" placeholder="Control Number" v-model="templateTaskObj.controlNumber" :class="{'is-invalid': v$.templateTaskObj.controlNumber.$error }"/>
                                            <div v-if="v$.templateTaskObj.controlNumber.$error " class="text-red-500">
                                                <div class="error-text" v-if="v$.templateTaskObj.controlNumber.required.$invalid ">Required</div>
                                            </div>
                                        </div> -->
                                        <div class="upperspacing">
                                            <label class="controllabel text-xs">Assigned To</label>
                                            <div class="mt-2">
                                            <multiselect
                                                v-model="templateTaskObj.assignee"
                                                :options="userOptions"
                                                :showNoOptions="false"
                                                @search-change="asyncFind"
                                                :limit-text="limitText"
                                                :multiple="false"
                                                :hide-selected="true"
                                                :close-on-select="true"
                                                :clear-on-select="true"
                                                open-direction="bottom"
                                                label="label"
                                                track-by="value"    
                                                :searchable="true"
                                                :hideArrow="false"
                                                placeholder="Assigned to"
                                                class="custom-multiselect userSelect"
                                                :class="{
                                                    'is-invalidmultiselect': v$.templateTaskObj.assignee.$error,
                                                    'has-options': userOptions && userOptions.length > 0,
													'no-options': !userOptions.length &&  searchValue !== ''
                                                }"
                                            >
                                                <template v-slot:noResult>
                                                    <span>No Members Found</span>
                                                </template>
                                            </multiselect>
                                            <div v-if="v$.templateTaskObj.assignee.$error " class="text-red-500">
                                                <div class="error-text" v-if="v$.templateTaskObj.assignee.required.$invalid ">Required</div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="upperspacing">
                                        <label class="controllabel text-xs">Description</label><br />
                                        <textarea name="Description" placeholder="Description" id="" class="inputboxstyling mt-2" v-model.trim="templateTaskObj.description" :class="{'is-invalid': v$.templateTaskObj.description.$error }"></textarea>
                                        <div v-if="v$.templateTaskObj.description.$error " class="text-red-500">
                                            <div class="error-text" v-if="v$.templateTaskObj.description.required.$invalid ">Required</div>
                                        </div>
                                    </div>
                                    
                                </div>
                                
                                <div class="buttonposition flex justify-center items-center mb-4 mx-0 mt-4">
                                    <button class=" mr-2" :class="(JSON.stringify(templateTaskObjDummy) == JSON.stringify(templateTaskObj)) ? 'btndisabled pointer-events-none ' : 'btnprimary'" @click="onCancelbtn()">Reset</button>
                                    <button class="" :class="(JSON.stringify(templateTaskObjDummy) == JSON.stringify(templateTaskObj)) ? 'btndisabled pointer-events-none ' : 'btnprimary'" @click="clickOnSubmitToCreateTask()">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </popup>
        </div>
	</div>
</template>

<script lang="ts">
import { emitter,toast } from '@/main';
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import breadCrumbs from '@/components/breadCrumbs.vue';
import tableData from '@/components/tableData.vue';
import popup from '@/components/popup.vue';
// import { template } from 'lodash';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import toolTip from '@/components/toolTip.vue'
  
export default defineComponent({
  data(): any {
    return {
        v$: useVuelidate(),
        headers:['ccid','title','description','framework_controlNo'],
        routesArray:[],
        controlsArray:[],
        createTaskPopup: false,
        presentTemplateObject:[],
        userOptions:[],
        optionUserArray:[],
        templateTaskObj:{
            mainTaskName:'',
            startDate:'',
            dueDate:'',
            controlNumber:'',
            assignee:'',
            description:''
        },
        templateTaskObjDummy:{},
        addedControlArray:[],
        keysOfActiveControls:[],
        allProcess:[],
        presentProcessObj:{},
        disableStart:true,
        toolTipActive:false,
        toolTipText:'',
        dataLoading:true,
        searchValue:''
        };
    },
    components:{
        breadCrumbs,
        popup,
        tableData,
        Multiselect,
        toolTip
    },
    computed: {
		...mapGetters({ userInfo: 'userInfo' }),
        today() {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0'); 
            const day = String(today.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
    },
    methods:{
        addTemplate(){
            this.$router.push({name:'createTemplate'});
        },
        checkWhetherTasksCreated(presentTemplateObject:any){
            if(((((presentTemplateObject.controls != null||presentTemplateObject.controls!=undefined) && presentTemplateObject.controls.length!=0)) && !(this.checkTasks(presentTemplateObject)))){
                return true
            } else {
                return false
            }
        },
        checkTasks(obj:any){
            if(Object.keys(obj).includes('tasks')){
                return true
            }else{
                return false
            }
        },
        filterOpen() {
			this.showFilters = !this.showFilters;
			// if (this.showFilters == true) {
            //     this.dummyList = this.savedAuditSets;
            // } else {
            //     this.savedAuditSets = this.dummyList;
            // }
			emitter.emit('visible', this.showFilters);
		},
        openCalendar(event: any) {
            event.target.showPicker();
        },
        checkForStartDate(){
			if(this.templateTaskObj.dueDate != ''){
				if(this.templateTaskObj.startDate > this.templateTaskObj.dueDate){
					this.templateTaskObj.dueDate = ''
				}
			}
		},
        startTaskPopup(){
            this.createTaskPopup = true
        },
        onCloseAddPopup(){
            this.createTaskPopup = false
            this.v$.$reset();
            this.templateTaskObj.mainTaskName = '',
            this.templateTaskObj.startDate = '',
            this.templateTaskObj.startDate = '',
            this.templateTaskObj.dueDate = '',
            this.templateTaskObj.controlNumber = '',
            this.templateTaskObj.assignee = '',
            this.templateTaskObj.description = ''
        },
        onCancelbtn(){
            this.v$.$reset();
            this.templateTaskObj.mainTaskName = '',
            this.templateTaskObj.startDate = '',
            this.templateTaskObj.startDate = '',
            this.templateTaskObj.dueDate = '',
            this.templateTaskObj.controlNumber = '',
            this.templateTaskObj.assignee = '',
            this.templateTaskObj.description = ''
        },
        limitText (count:any) {
			// return `and ${count} other countries`
		},
		asyncFind(query:any){
            this.searchValue = query;
			if(query == ''){
				this.userOptions = []
			}else if(query.length > 0){
				this.userOptions = this.optionUserArray.filter((obj:any)=>{return obj.label.toLowerCase().includes(query.toLowerCase())})
			}
		},
        editTemplate(){
            this.$router.push({name:'editTemplate',params:{id:1}});
        },
        clickOnSubmitToCreateTask(){
            this.v$.$touch();
            // this.v$.causeActionObj.$invalid
            if(!this.v$.templateTaskObj.$invalid){
                this.createTaskForTemplate(this.templateTaskObj)
                this.createTaskPopup = false
                this.v$.$reset();
            }
            // this.createTaskForTemplate()
        },
        async createTaskForTemplate(obj: any){
            let templateId:any = this.$route.params.templateId
            //here task api
            // /api/org/trigger/workflow/:workflowId/planner/template/task

            // WORKFLOW API 3040

            // POST

            // [
            //   {
            //     mainTaskName: 'asdfvf',
            //     startDate:'',
            //     dueData:'',
            //     assignee:'',
            //     description:'',
            //     linkedTemplateId:'dkncdicdiubciuejk',
            //     createdAt:'',
            //     createdBy:'',
            //   }
            // ]
            // 66a0ce70a18432dc59960b26----->workflowId
            
            const payload: any = {
				mainTaskName: obj.mainTaskName,
                startDate: obj.startDate,
                dueDate:obj.dueDate,
                assignee:obj.assignee.value,
                description:obj.description,
                linkedTemplateId:templateId,
                createdBy:this.userInfo._id,
            };
            // toast.info('Task Created', {
            //             timeout: 1000,
            //             closeOnClick: true,
            //             closeButton: 'button',
            //             icon: true
            //         });
            let workflowId: any = "669f7f1c978cb707f468a5f9"
            await this.$http
				.post(`${process.env.VUE_APP_WORKFLOW_API}/api/org/trigger/workflow/${process.env.VUE_APP_PLANNER_WORKFLOW_ID}/planner/template/task`,[payload])
				.then((result: { data: any }) => {
                    toast.info('Task Created', {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
				})
				.catch((error: any) => {
                    toast.error(` ${error}`, {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
			});

        },
        async onClickArchiveBtn(){
            await this.ArchiveTemplate();
            this.$router.push({ name: 'archiveTemplates' });
        },
        async ArchiveTemplate(){
            let templateId:any = this.$route.params.templateId
            // /api/org/template/:templateId/archive
            // POST

            // {updatedAt:'knedle12124n',updatedBy:'elkdcbe98378yu'}
            const payload: any = {
				updatedBy:this.userInfo._id
            };
            await this.$http
				.post(`${process.env.VUE_APP_PLANNER_API}/api/org/template/${templateId}/archive`,payload)
				.then((result: { data: any }) => {
                    // console.log("Update data",result.data)
                    
				})
				.catch((error: any) => {
                    toast.error(` ${error}`, {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
			});
            
        },
        async getActiveTemplates(typeId: any){
            // /api/org/type/:typeId/templates/getAll

            // GET

            // type 1 for all active templates

            // type 2 for all archive templates
            await this.$http.get(`${process.env.VUE_APP_PLANNER_API}/api/org/type/${typeId}/templates/getAll`).then((result: any) => {
				// console.log('active templates data', result.data);
                
			});

        },
        async getOneTemplateDetails() {
            let templateId:any = this.$route.params.templateId
			await this.$http.get(`${process.env.VUE_APP_PLANNER_API}/api/org/template/${templateId}/get`).then((result: any) => {
                this.presentTemplateObject = result.data
			});
            let templateObj:any
            let finaltemplateObj:any
            let framework_controlNo :any
            this.presentTemplateObject.controls.forEach((element:any) => {
                templateObj=this.allActiveControls.filter((obj: any)=>{return obj._id === element})
                templateObj.forEach((obj: any) => {
                    if(Object.keys(obj).includes('frameworks')){
                        framework_controlNo = obj.frameworks.map((framework: any) => {
                                return {
                                    framework: framework.framework,
                                    controls: framework.controls
                                };
                            });
                    }else{
                        // framework_controlNo =  {
                        //         control:{label:obj.controlNumber, value:obj._id},
                        //         frameworkName:'Internal Controls'
                        //     }
                        
                    }
                    finaltemplateObj= {
                        ccid:obj.clientUniqueId != undefined ? obj.clientUniqueId : 'N/A',
                        title:obj.controlTitle != undefined ? obj.controlTitle : 'N/A',
                        description: (obj.controlGuidance != undefined && obj.controlGuidance != '') ? obj.controlGuidance : 'N/A',
                        framework_controlNo:framework_controlNo != undefined ? framework_controlNo : 'N/A',
                    }
                    this.controlsArray.push(finaltemplateObj)
                });
                
                
            });			
		},
        async getAllActiveControls(){
            await this.$http
				.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/controls/active`)
				.then((result: { data: any }) => {
                    this.allActiveControls = result.data;
				})
				.catch((error: any) => {
                    toast.error(` ${error}`, {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
				});
                
        },
        async getAllBusinessProcesses() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${20006}`).then((result: any) => {
				this.allProcess = result.data
            });
            let processId:any = this.$route.params.processId
            let obj:any = this.allProcess.find((process:any)=>{
                return process._id==processId
            })
            this.presentProcessObj=obj
        },
        async getAllActiveUsers() {
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/active/getall`).then((res: any) => {
				this.orgUsersList = res.data.filter((user: any) => {
					return user.isActive == true;
				});
				for (var i = 0; i < this.orgUsersList.length; i++) {
					this.optionUserArray.push({ label: this.orgUsersList[i].name, value: this.orgUsersList[i]._id });
				}
			});
		},
    },
    validations(){
        return {
            templateTaskObj:{
                mainTaskName:{required},
                startDate:{required},
                dueDate:{required},
                assignee:{required},
                description:{required}
            },
        }
//         [
//   {
//     mainTaskName: 'asdfvf',
//     startDate:'',
//     dueData:'',
//     assignee:'',
//     description:'',
//     linkedTemplateId:'dkncdicdiubciuejk',
//     createdAt:'',
//     createdBy:'',
//   }
// ]

    },
    async  created() {
        this.dataLoading = true;

        await this.getAllActiveUsers();
        await this.getAllActiveControls();
        await this.getOneTemplateDetails();
        await this.getActiveTemplates(20501);
        await this.getAllBusinessProcesses();

        this.dataLoading = false;
        emitter.off('activiteToolTip');
			emitter.on('activiteToolTip', (data: any) => {
				this.toolTipActive = true;
				this.toolTipText = data.tipText
			});
			emitter.off('deActiviteToolTip');
			emitter.on('deActiviteToolTip', (data: any) => {
				this.toolTipActive = false;
				this.toolTipText = ''
			});
        this.routesArray = [
            { name: 'Archive Template', routeName: 'archiveTemplates' },
			// { name: this.presentProcessObj.businessProcessName, routeName: 'template' },
            { name: 'Template', routeName: 'templateDetails' }
        ];
        this.templateTaskObjDummy = {...this.templateTaskObj}
    }
  
  });



</script>

<style scoped>

</style>